'use strict';

const React = require('react');
const SIZE = {
	'original' : 'original',
	'medium_43': 'traditional',
	'small': 'wide',
	'medium': 'wide',
	'large': 'wide',
	'extralarge': 'wide',
	'medium_cinema': 'cinema',
	'large_cinema': 'cinema',
	'extralarge_cinema': 'cinema',
	'medium_portrait': 'portrait',
	'large_portrait': 'portrait',
	'large_square': 'square',
	'square': 'square',
	'medium_imax': 'imax',
	'large_imax': 'imax',
	'extralarge_imax': 'imax'
};

const Image = (props) => {
	if (!props.model || !props.model.alternateSrc) { return (<noscript/>); }
	
	const { type = 'small', model, imageClass, ...other} = props;
	const src = model.alternateSrc.replace(/\{image_versions.name\}/, type);
	const title = model.photographer? 'Foto: ' + model.photographer : '';
	const wrapperClass = 'svtse_image-wrapper svtse_image-wrapper--' + SIZE[type];

	return (
		<div className={imageClass}>
			<div className={wrapperClass}>
				<img className="svtse_image-wrapper__img" src={src} alt={model.altText} title={title} {...other} />
			</div>
		</div>
	);
};

Image.propTypes = { 
	type: React.PropTypes.oneOf(Object.keys(SIZE)),
	imageClass: React.PropTypes.string,
	model: React.PropTypes.shape({
		id: React.PropTypes.string.isRequired,
		title: React.PropTypes.string,
		alternateSrc: React.PropTypes.string.isRequired,
		altText: React.PropTypes.string,
		photographer: React.PropTypes.string
	}).isRequired
};

const Caption = (props) => {
	const {text, photographer, ...other} = props;
	if (!text) { return (<noscript/>); }
	return (
		<figcaption {...other}>
			{text} {photographer}
		</figcaption>
	);
};

const Picture = (props) => { 
	if(!props.model) { return (<noscript/>); }
	
	const { type = 'small', imageClass, caption, captionClass, model, ...other } = props;
	const photographer = model.photographer? 'Foto: ' + model.photographer : '';

	// If the API can't include it's image include
	if (!model.src) {
		const wrapperClass = 'svtse_image-wrapper svtse_image-wrapper--' + SIZE[type] + ' svtse_image-wrapper--overflow';
		return (
			<figure {...other}>
				<div className={wrapperClass}>
					<img className="svtse_image-wrapper__img" alt="Bilden kan tyvärr ej laddas in" />
				</div>
			</figure>
		);
	}

	return (
		<figure {...other}>
			<Image imageClass={imageClass} model={model} type={type}/>
			<Caption className={captionClass} text={caption} photographer={photographer}/>
			{props.children}
		</figure>
	);
};

Picture.propTypes = {
	type: React.PropTypes.oneOf(Object.keys(SIZE)),
	model: React.PropTypes.object,
	imageClass: React.PropTypes.string,
	caption: React.PropTypes.string,
	captionClass: React.PropTypes.string
};

module.exports = Picture;



/** WEBPACK FOOTER **
 ** ./app/components/elements/Picture.js
 **/